import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { getGetSelfQueryKey, getSelf } from '../api/generated';

const whoamiAtom = atomWithSuspenseQuery(() => ({
  queryKey: [...getGetSelfQueryKey()],
  queryFn: () => getSelf(),
}));

export { whoamiAtom };
